import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const cloudEnableAsyncPortalEnabled: boolean = isFeature('cloud-enable-async-portal');
